import "reflect-metadata";
import {inject, injectable} from "inversify";
import {InternalChatRepository} from "@dropDesk/domain/repositories/internal_chat/internal_chat.repository";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";
import {InternalChatListFilters} from "@dropDesk/domain/entities/internal_chat/internal_chat_list_filters";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {CancelTokenSource} from "axios";

@injectable()
export class ListInternalChatsUseCase {
    private _repository: InternalChatRepository;

    constructor(@inject(InternalChatRepository) repository: InternalChatRepository) {
        this._repository = repository;
    }

    public call(filters: InternalChatListFilters): Promise<ListPaginationEntity<InternalChatEntity>> {
        return this._repository.listInternalChats(filters);
    }
}
